import axios from 'axios';
import config from './config'
import { util, lg } from 'utils';

let base = util.getDomain();

/*代理商*/
export const GetAgentOrderList = params => { return axios.get(`${base}/api/AgentOrder/GetAgentOrderList`, { params: params }); };
//查看
export const GetAgentOrderStockInfo = params => { return axios.get(`${base}/api/AgentOrder/GetAgentOrderStockInfo`, { params: params }); };
//添加反馈
export const ERP_AgentFedBackAdd = params => { return axios.post(`${base}/api/AgentOrder/ERP_AgentFedBackAdd`, params, config); };
//获取出库数据
export const LoadDataForAgentReceive = params => { return axios.get(`${base}/api/AgentOrder/LoadDataForAgentReceive`, { params: params }); };
//收货提交
export const StockOutReceive = params => { return axios.post(`${base}/api/AgentOrder/StockOutReceive`, params, config); };
//获取当个代理商信息
export const GetByAgentId = params => { return axios.get(`${base}/api/Agent/GetByAgentId`, { params: params }); };
export const GetNewByAgentId = params => { return axios.get(`${base}/api/Agent/GetNewByAgentId`, { params: params }); };
//获取当个代理商信息
export const GetNewAgentByCustomerId = params => { return axios.get(`${base}/api/Agent/GetNewAgentByCustomerId`, { params: params }); };
//代理商转移
export const AgentTransfer = params => { return axios.post(`${base}/api/Agent/AgentTransfer`, params, config); };
//清空IMEI
export const ClearIMEI = params => { return axios.post(`${base}/api/Agent/ClearIMEI`, params, config); };

export const GetProjectTypeSignMateriel = params => { return axios.get(`${base}/api/Agent/GetProjectTypeSignMateriel`, { params: params }); };



// WEBPACK FOOTER //
// ./src/api/agentApi.js